var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"max-w-7xl mx-auto py-10 sm:px-6 lg:px-8"},[_c('create-team-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }